module.exports = __webpack_public_path__ + "static/media/national-psoriasis-foundation-logo.232f2f2e.png";